import { Dropdown } from './menus';

let style;
let menus = [];
let mediaQueries = {};
let element = document.querySelector('.js-navigation');

export function init() {
	if (!element) {
		return;
	}

	style = window.getComputedStyle(element);

	mediaQueries = {
		expandedMenus: style.getPropertyValue('--expanded-menus'),
		verticalCurve: style.getPropertyValue('--vertical-curve'),
	};

	Array.from(document.querySelectorAll('.js-nav-header')).forEach(e => {
		menus.push(Dropdown(e));
	});

	element.addEventListener('dialog:open', () => {
		calcLayout();
		window.addEventListener('resize', resize);
	});

	element.addEventListener('dialog:close', () => {
		window.removeEventListener('resize', resize);
	});
}

function resize() {
	calcLayout();
}

function calcLayout() {
	let main = document.querySelector('.js-header-main');
	let curve = document.querySelector('.js-navigation-curve');
	let navigationHeader = document.querySelector('.js-navigation-header');

	curve.style.top = '';

	if (main && navigationHeader) {
		navigationHeader.style.height = `${main.clientHeight}px`;
	}

	if (mediaQueries.verticalCurve && window.matchMedia(mediaQueries.verticalCurve).matches) {
		curve.style.top = `${-curve.getBoundingClientRect().top}px`;
	}

	menus.forEach(menu => {
		if (!mediaQueries.expandedMenus || !window.matchMedia(mediaQueries.expandedMenus).matches) {
			menu.create();
		} else {
			menu.destroy();
		}
	});
}
